import {environment} from "../../environments/environment";

export const CAPTCHA_STATUS_API = environment.taxpayer_base_url + '/api/captcha/get-status';

export const RECAPTCHA_API_LIST: string[] = [];

export const CHANGE_PASS_CAPTCHA_PATH = '/filingservice/v3/api/auth/change-pass';

export function setRecaptchaApiList(paths: string[] | null | undefined): void {
  RECAPTCHA_API_LIST.length = 0;
  if (Array.isArray(paths) && paths.length) {
    RECAPTCHA_API_LIST.push(...paths);
  }
  if (RECAPTCHA_API_LIST.indexOf(CHANGE_PASS_CAPTCHA_PATH) < 0) {
    RECAPTCHA_API_LIST.push(CHANGE_PASS_CAPTCHA_PATH);
  }
}
